import { render, staticRenderFns } from "./channel-button.vue?vue&type=template&id=42a359e6&scoped=true&"
import script from "./channel-button.vue?vue&type=script&lang=js&"
export * from "./channel-button.vue?vue&type=script&lang=js&"
import style0 from "./channel-button.vue?vue&type=style&index=0&id=42a359e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a359e6",
  null
  
)

export default component.exports